import axiosInstance from './axiosInstance';

export async function saveSubscription(subscription) {
  const response = await axiosInstance.post('/push/save-subscription.php', subscription.toJSON());
  return response.data;
}